import { Link } from 'react-router';
import { cn } from '@/lib/utils';

/** Productnaam in type met een oranje stip; er is (nog) geen logo. */
export function Wordmark({ to, className }: { to?: string; className?: string }) {
  const content = (
    <>
      <span className="size-2.5 rounded-full bg-primary" aria-hidden="true" />
      Train2Volley
    </>
  );
  const classes = cn(
    'inline-flex items-center gap-2 text-[17px] font-bold tracking-[-0.03em] whitespace-nowrap text-foreground no-underline',
    className,
  );
  return to ? (
    <Link to={to} className={cn(classes, 'rounded-sm')}>
      {content}
    </Link>
  ) : (
    <span className={classes}>{content}</span>
  );
}
